import type { ColumnDef } from "@tanstack/react-table";
import type { KomponenKegiatan } from "../api/get-komponen";

export const columns: ColumnDef<KomponenKegiatan>[] = [
  {
    accessorKey: 'kode_komponen',
    header: 'Kode',
  },
  {
    accessorKey: 'komponen_kegiatan',
    header: 'Komponen Kegiatan',
  },
  {
    accessorKey: 'satuan',
    header: 'Satuan',
  },
  {
    accessorKey: 'sumber_data',
    header: 'Sumber Data',
  },
];
